const { AbilityBuilder, Ability } = require('@casl/ability');

function defineAbilityFor(user) {
  const { rules, can, cannot } = AbilityBuilder.extract();

  if (user.role === 'OPTIGUARD') {
    can('manage', 'all');
  } else if (user.role === 'ADMINISTRATOR') {
    can('manage', 'Users');
    can('manage', 'Groups');
    can('manage', 'Salons');
  } else if (user.role === 'SUPERVISOR') {
    can('access', 'Dashboard');
    can('access', 'Reports');
    cannot('delete', 'all');
  } else {
    can('access', 'Dashboard');
    can('access', 'Reports');
  }

  return new Ability(rules);
}
